import * as React from 'react';
import ComponentSequence from '../Components/Compositional/ComponentSequence';
import SpinningProgressWrapper from '../Components/Compositional/SpinningProgressWrapper';
import Container from '../Components/Container';
import ProgressStepsHorizontal from '../Components/ProgressSteps';
import ProgressStepsVertical from '../Components/ProgressStepsVertical';
import Row from '../Components/Row';
import WarningBanner from '../Components/WarningBanner';
import WorldNet3DSecure from '../Components/WorldNet/WorldNet3DSecure';
import { SupportedCards, WorldNetConfig } from '../Components/WorldNet/WorldNetConfig';
import DirectDebitRespository from '../Helpers/DirectDebitRespository';
import WorldNetDonationRepository from '../Helpers/WorldNetDonationRepository';
import Product from '../Models/Product';
import * as Modules from '../Modules';
import { Communication } from '../Modules/GdprModule';
import { HowHeardAboutUsOption } from '../Modules/HowHeardAboutUsModule';
import { DonationTypeOption } from '../Modules/DonationTypeModule';
import { DefaultIbanBankAccountDetails } from '../Types/Payments/IbanPaymentDetails';
import { DefaultIDebitCardDetails } from '../Types/Payments/IDebitCardDetails';
import { CardPaymentDetails, DefaultCreditCardPaymentDetails } from '../Types/Payments/PaymentDetails';
import * as SignupJourney from './SignupJourney';
import { PaymentDetails } from './SignupJourney/BarnardosPayment';
import Country from './Types/Country';
import DonationArea from './Types/DonationArea';
import Member from './Types/Member';
import Project from './Types/Project';
import UISetting from './Types/UISetting';

require('../css/membership-signup.css');
require('../css/barnardos.css');
require('../css/barnardos-mobile-specific.css');

const titlesList = ['Ms', 'Miss', 'Mrs', 'Mr', 'Dr'];

interface Props {
  rhythmApiUrl: string;
  loqateApiKey: string;

  addressSelectorEnabled: boolean;
  reCaptchaKey?: string;

  donationTypeOptions: DonationTypeOption[];
  donationTypeOtherId: string;
  donationTypeDefaultId: string;

  product: Product;
  project: Project;
  termsAndConditionsText: string;
  donationAmountSelectionTitle: string;
  donationAmountSelectionDisclaimer: string;
  donationAmountSelectionHeader: string;
  uiSetting: UISetting;
  loqateValidation?: boolean;
  useIBANBIC?: boolean;

  communications: {
    title: string;
    introduction?: string;
    disclaimer?: string;
    groupName: string;
    description: string;
    dynamicsId: string;
  };

  howHeardAboutUsOptions: HowHeardAboutUsOption[];
  howHeardAboutUsOtherId: string;
  howHeardAboutUsdefaultId: string;

  worldNetConfig: WorldNetConfig;
  commentEnabled: boolean;
  additionalCSS?: string[] | null;

  footerText?: string;
  ddType?: string;
  creditorName?: string;
  creditorID?: string;
  creditorAddress?: string;
  countryList?: Country[];
  defaultTheEndDate: boolean | null;
  campaignId?: string;

  showOrganisationField?: boolean;
  mapToCampaign?: 'HowHeardAboutUs' | 'ReasonForDonating';
}

interface State {
  displayIndex: number;

  isProcessing: boolean;
  processingMessage?: string;

  product: Product;
  primaryMember: Member;
  paymentDetails: PaymentDetails;

  selectedChannels: ('email' | 'phone' | 'post' | 'sms')[];

  activeArea: DonationArea;
  showThankyouMsg: boolean;
  personalDetailIndex: number;
  paymentIndex: number;
  summaryIndex: number;
  uiSetting: UISetting;

  donationTypeSelectedId: string;
  donationTypeCustomValue: string;

  howHeardAboutUsSelectedId: string;
  howHeardAboutUsCustomValue: string;

  worldNet3DSecure: {
    orderId: string | null;
    mpiRef: string | null;
  };

  errors: string[];
  commentEnabled: boolean;
  additionalCSS?: string[] | null;

  isDirectDebitEnable: boolean;
  paymentErrorMessage?: string;
  ddMonth?: string;
  ddYear?: string;
}

export default class BarnardosDonationForm extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      displayIndex: 0,
      isProcessing: false,
      processingMessage: undefined,

      product: props.product,

      primaryMember: {
        personalInfo: {
          email: '',
          confirmEmail: '',
          title: '',
          firstName: '',
          lastName: '',
          dateOfBirth: null,
          phone: '',
          organisation: ''
        },
        address: {
          postcode: '',
          line1: '',
          line2: '',
          line3: '',
          town: '',
          county: '',
          country: 'Ireland',
          countryIso: 'IE'
        },
        donation: {
          comment: ''
        }
      },

      selectedChannels: [],

      paymentDetails: DefaultCreditCardPaymentDetails,

      activeArea: DonationArea.Select,
      showThankyouMsg: false,
      personalDetailIndex: 2,
      paymentIndex: 3,
      summaryIndex: 4,
      uiSetting: this.props.uiSetting,

      donationTypeSelectedId: '',
      donationTypeCustomValue: '',

      howHeardAboutUsSelectedId: '',
      howHeardAboutUsCustomValue: '',

      worldNet3DSecure: {
        orderId: null,
        mpiRef: null,
      },

      errors: [],
      commentEnabled: this.props.commentEnabled,
      additionalCSS: this.props.additionalCSS,
      isDirectDebitEnable: false
    };
  }

  updatepaymentErrorDetail = (errorText: string, ddMonth: string, ddYear: string) => {
    this.setState({ paymentErrorMessage: errorText, ddMonth: ddMonth, ddYear: ddYear });
  }

  clearErrors = () => {
    this.setState({errors: [] });
   };

  updateProcessingDisplay = (processingMessage?: string) => {
    this.setState({ isProcessing: processingMessage !== undefined, processingMessage: processingMessage });
  }

  updateDonationDetails = (amount: number, paymentMethod: 'creditcard' | 'bankaccount' | 'directdebit', paymentSelection: 'monthly' | 'single') => {

    if (paymentMethod === 'creditcard') {

      this.setState(prevState => ({
        product: {
          ...prevState.product,
          priceInPence: amount,
          paymentSelection: paymentSelection,
        },
        paymentDetails: {
          ...DefaultCreditCardPaymentDetails,
          cardType: this.state.product.defaultCardType,
        },
      }));

    } else if (paymentMethod === 'bankaccount') {
      this.setState({ isDirectDebitEnable: true });
      this.setState(prevState => ({
        product: {
          ...prevState.product,
          priceInPence: amount,
          paymentSelection: paymentSelection,
        },
        paymentDetails: {
          ...DefaultIbanBankAccountDetails,
        },
      }));
    } else {
      this.setState({ isDirectDebitEnable: true });
      this.setState(prevState => ({
        product: {
          ...prevState.product,
          priceInPence: amount,
          paymentSelection: paymentSelection,
        },
        paymentDetails: {
          ...DefaultIDebitCardDetails,
        },
      }));
    }

    this.handleNext();
  }

  handleNext = () => {
    this.setState({ displayIndex: this.state.displayIndex + 1 });
    this.updateActiveTab(this.state.displayIndex, this.state.displayIndex - 1);
    this.updateActiveClassforMobileDropdown(this.state.displayIndex + 1, this.state.displayIndex);

  };

  updateActiveTab(currentIdex: number, previousIndex: number) {
    var previousgId = document.getElementById('gift_' + previousIndex);
    var previousgiftdivId = document.getElementById('giftDiv_' + previousIndex);
    var previousgiftbodyId = document.getElementById('giftBody_' + previousIndex);
    var gId = document.getElementById('gift_' + currentIdex);
    var giftdivId = document.getElementById('giftDiv_' + currentIdex);
    var giftbodyId = document.getElementById('giftBody_' + currentIdex);
    if (previousgId != null && previousgiftdivId != null && previousgiftbodyId != null && gId != null && giftdivId != null && giftbodyId != null) {
      gId.style.pointerEvents = '';
      gId.className = 'active';
      giftdivId.classList.add('active');
      giftbodyId.style.display = 'block';
      previousgId.className = previousgId.className.replace(/\active\b/g, '');
      previousgiftdivId.className = previousgiftdivId.className.replace(/\active\b/g, '');
      previousgiftbodyId.style.display = '';
    }
  }

  updateActiveClassforMobileDropdown(currentIdex: number, previousIndex: number) {
    var previousddId = document.getElementById('dd_' + previousIndex);
    var ddId = document.getElementById('dd_' + currentIdex);
    if (previousddId != null && ddId != null) {
      ddId.className = 'active';
      previousddId.className = previousddId.className.replace(/\active\b/g, '');
      previousddId.classList.add('clickable');
    }
    if (previousIndex > currentIdex && previousddId != null) {
      previousddId.classList.remove('clickable');
    }
  }

  updateAccordionIndex() {
    this.setState({ personalDetailIndex: 1 });
    this.setState({ paymentIndex: 2 });
    this.setState({ summaryIndex: 3 });
  }

  updatePaymentDetails = (
    mutate: (paymentDetails: PaymentDetails) => void
  ): void => {
    let paymentDetailClone = { ...this.state.paymentDetails };

    mutate(paymentDetailClone);

    this.setState({ paymentDetails: paymentDetailClone });
  };

  communicationUpdated = (id: string, type: 'email' | 'post' | 'phone' | 'sms', value: boolean) => {
    const channels = [...this.state.selectedChannels];
    const channelIndex = this.state.selectedChannels.findIndex(c => c === type);

    if (channelIndex > -1) {
      if (!value) {
        channels.splice(channelIndex, 1);
      }
    } else {
      channels.push(type);
    }

    this.setState({ selectedChannels: channels });
  }

  howHeardAboutUsOptionSelected = (selectedOptionId: string): void => {
    this.setState({ howHeardAboutUsSelectedId: selectedOptionId });
  }

  howHeardAboutUsCustomValueChanged = (customValue: string): void => {
    this.setState({ howHeardAboutUsCustomValue: customValue });
  }

  donationTypeOptionSelected = (selectedOptionId: string): void => {
    this.setState({ donationTypeSelectedId: selectedOptionId });
  }

  donationTypeCustomValueChanged = (customValue: string): void => {
    this.setState({ donationTypeCustomValue: customValue });
  }

  getTransactionType = (paymentSelection: string): string => {
    let transactionType = '';
    if (paymentSelection === 'single') {
      transactionType = 'One-off';
    }
    if (paymentSelection === 'monthly') {
      transactionType = 'Recurring ';
    }
    return transactionType;
  }

  handleWorldNet3DSecureResponse = (result: string, mpiRef: string, orderId: string): void => {

    // Approved
    if (result === 'A') {
      this.setState({ worldNet3DSecure: { mpiRef: mpiRef, orderId: orderId } });
      this.handleSubmit();
    } else if (result === 'D') { // Declined
      this.setState({ errors: [...this.state.errors, '3D Secure Declined.'] });
    } else { // Unexpected
      this.setState({ errors: [...this.state.errors, 'Unknown 3D Secure response'] });
    }
  }

  handleSubmit = async () => {
    this.clearErrors();
    this.updateProcessingDisplay('Securely handling your request. This may take a minute.');

    try {
      var communicationsData: Communication[] = [];
     
      for (var i = 0; i < this.state.selectedChannels.length; i++) {
        var localComm: Communication = {
          id: this.props.communications.dynamicsId,
          description: '',
          name: '',
          email: (this.state.selectedChannels[i] === 'email') ? true : undefined ,
          phone: (this.state.selectedChannels[i] === 'phone') ? true : undefined ,
          post: (this.state.selectedChannels[i] === 'post') ? true : undefined ,
          sms: (this.state.selectedChannels[i] === 'sms') ? true : undefined ,
        };
        communicationsData.push(localComm);
      }

      if (communicationsData.length === 0) {
        var optOutComm: Communication = {
          id: this.props.communications.dynamicsId,
          description: '',
          name: '',
          email: false ,
          phone: false ,
          post: false,
          sms: false ,
        };
        communicationsData.push(optOutComm);
      }
  
      if (this.state.paymentDetails.kind === 'creditcard') {

        if (!this.state.worldNet3DSecure.orderId || !this.state.worldNet3DSecure.mpiRef) {
          this.setState({ errors: [...this.state.errors, '3D Secure not complete, cannot make donation.'] });
          return;
        }      

        if (this.state.product.paymentSelection === 'monthly') {

          await WorldNetDonationRepository.MakeRecurringDonation(
            this.props.rhythmApiUrl,
            {
              productId: this.state.product.id,
              amountPence: this.state.product.priceInPence,
              projectId: this.props.project.id,
              startDate: new Date(Date.UTC(
                Number('20' + this.state.paymentDetails.startDonationFrom.year),
                Number(this.state.paymentDetails.startDonationFrom.month) - 1,
                Number(this.state.paymentDetails.dateToDonateInMonth))),
            },
            {
              id: this.state.donationTypeSelectedId,
              otherText: this.state.donationTypeCustomValue,
            },
            {
              id: this.state.howHeardAboutUsSelectedId,
              otherText: this.state.howHeardAboutUsCustomValue,
            },
            {
              title: this.state.primaryMember.personalInfo.title,
              firstName: this.state.primaryMember.personalInfo.firstName,
              lastName: this.state.primaryMember.personalInfo.lastName,
              emailAddress: this.state.primaryMember.personalInfo.email,
              telephone: this.state.primaryMember.personalInfo.phone,
              address: this.state.primaryMember.address,
              organisation: this.state.primaryMember.personalInfo.organisation,
            },
            {
              cardType: this.state.paymentDetails.cardType,
              cardNumber: this.state.paymentDetails.cardNumber,
              cvv: this.state.paymentDetails.cvc,
              expiryDate: this.state.paymentDetails.expDate,
              cardHolderName: this.state.paymentDetails.cardHolderName,
              orderId: this.state.worldNet3DSecure.orderId,
              mpiRef: this.state.worldNet3DSecure.mpiRef
            },
            false,
            communicationsData,
            this.state.primaryMember.donation,
            this.props.defaultTheEndDate,
            this.props.mapToCampaign
          ).catch((error) => {
            this.state.errors.push(error); 
                            });
        } else {

          await WorldNetDonationRepository.MakeDonation(
            this.props.rhythmApiUrl,
            {
              productId: this.state.product.id,
              amountPence: this.state.product.priceInPence,
              projectId: this.props.project.id,
            },
            {
              id: this.state.donationTypeSelectedId,
              otherText: this.state.donationTypeCustomValue,
            },
            {
              id: this.state.howHeardAboutUsSelectedId ? this.state.howHeardAboutUsSelectedId : this.props.howHeardAboutUsdefaultId,
              otherText: this.state.howHeardAboutUsCustomValue,
            },
            {
              title: this.state.primaryMember.personalInfo.title,
              firstName: this.state.primaryMember.personalInfo.firstName,
              lastName: this.state.primaryMember.personalInfo.lastName,
              emailAddress: this.state.primaryMember.personalInfo.email,
              telephone: this.state.primaryMember.personalInfo.phone,
              address: this.state.primaryMember.address,
              organisation: this.state.primaryMember.personalInfo.organisation,
            },           
            communicationsData,
            {
              cardType: this.state.paymentDetails.cardType,
              cardNumber: this.state.paymentDetails.cardNumber,
              cvv: this.state.paymentDetails.cvc,
              expiryDate: this.state.paymentDetails.expDate,
              cardHolderName: this.state.paymentDetails.cardHolderName,
              orderId: this.state.worldNet3DSecure.orderId,
              mpiRef: this.state.worldNet3DSecure.mpiRef
            },
            false, 
            this.state.primaryMember.donation,
            this.props.defaultTheEndDate,
            this.props.mapToCampaign
          ).catch((error) => {
            this.state.errors.push(error); 
                            });

        }
      } else {

        const annualAmount = this.state.product.priceInPence * 12;
       
        await DirectDebitRespository.CreateBankPayment(
          this.props.rhythmApiUrl,
          {
            productId: this.state.product.id,
            annualAmountPence: annualAmount,
            projectId: this.props.project.id,
            startDate: (this.state.paymentDetails.kind === 'bankaccount') ? new Date(Date.UTC(
              Number('20' + this.state.paymentDetails.startDonationFrom.year),
              Number(this.state.paymentDetails.startDonationFrom.month) - 1,
              Number(this.state.paymentDetails.dateToDonateInMonth))) : new Date(Date.UTC(
                Number('20' + this.state.paymentDetails.startDonationFrom.year),
                Number(this.state.paymentDetails.startDonationFrom.month) - 1,
                Number(this.state.paymentDetails.paymentDay))),
          },
          {
            title: this.state.primaryMember.personalInfo.title,
            firstName: this.state.primaryMember.personalInfo.firstName,
            lastName: this.state.primaryMember.personalInfo.lastName,
            emailAddress: this.state.primaryMember.personalInfo.email,
            telephone: this.state.primaryMember.personalInfo.phone,
            address: this.state.primaryMember.address,
            organisation: this.state.primaryMember.personalInfo.organisation,
          },
          this.state.paymentDetails,
          false,
          communicationsData,
          {
            id: this.state.donationTypeSelectedId,
            otherText: this.state.donationTypeCustomValue,
          },
          {
            options: this.props.howHeardAboutUsOptions,
            otherId: this.props.howHeardAboutUsOtherId,
            selectedId: this.state.howHeardAboutUsSelectedId,
            customValue: this.state.howHeardAboutUsCustomValue,
          },
          this.state.primaryMember.donation,
          this.props.defaultTheEndDate,
          this.props.mapToCampaign
        ).catch((error) => {
          this.state.errors.push(error); 
                          });
      }

      this.updateProcessingDisplay(undefined);

    } catch (error) {
      let e = error as Error;
      this.updateProcessingDisplay(e.message);
    }

    if (this.state.errors.length === 0) {
      this.setState({ displayIndex: this.state.displayIndex + 1, showThankyouMsg: true });
    } else {
      this.setState({ displayIndex: this.state.displayIndex - 2, showThankyouMsg: false });
      this.renderErrors();
    }
  };

  updateMember = (mutate: (member: Member) => void): void => {
    let memberDetailClone = { ...this.state.primaryMember };

    mutate(memberDetailClone);

    this.setState({ primaryMember: memberDetailClone });
  };

  handleLabelClick = (index: number) => {
    if (index < this.state.displayIndex) {

      this.setState({ displayIndex: index });

      this.updateActiveTab(index, this.state.displayIndex);
      this.updateActiveClassforMobileDropdown(index, this.state.displayIndex);
    }
  };

  renderErrors = () => {
    return this.state.errors.map((error, index) => {
      return <WarningBanner message={error} key={index} />;
    });
  };

  renderProgressSteps = (
    count: number,
    displayIndex: number,
    children?: React.ReactChild[],
    uiSetting?: UISetting
  ) => {
    if (count) {
      count--;
    }

    const labels: string[] = [];

    for (let i = 0; i <= count; i++) {
      labels.push((i + 1).toString());
    }

    let progressStepType = this.props.uiSetting.progressStep;

    if (progressStepType.toLowerCase() === 'vertical') {
      return (
        <ProgressStepsVertical
          activeIndex={displayIndex}
          labels={labels}
          onLabelClick={this.handleLabelClick}
          children={children}
        />
      );
    } else {
      return (
        <ProgressStepsHorizontal
          activeIndex={displayIndex}
          labels={labels}
          onLabelClick={this.handleLabelClick}
          children={children}
        />
      );
    }

  };

  loadAdditionalCSS = () => {
    if (this.props.additionalCSS && this.props.additionalCSS.length > 0) {
      return (
        <div>
          {this.props.additionalCSS.map(function (object: string, i: number) {
            return <link key="" rel="stylesheet" type="text/css" href={object} />;
          })}
        </div>
      );
    } else {
      return (<div />);
    }
  }

  render() {
    const priceSymbol = this.state.product.priceSymbol;
    const gdprModuleCommunications = [
      {
        id: '1',
        name: this.props.communications.groupName,
        description: this.props.communications.description,
      },
      {
        id: this.props.communications.dynamicsId,
        name: '',
        description: '',
        email: this.state.selectedChannels.indexOf('email') !== -1,
      },
      {
        id: this.props.communications.dynamicsId,
        name: '',
        description: '',
        phone: this.state.selectedChannels.indexOf('phone') !== -1,
      },
      {
        id: this.props.communications.dynamicsId,
        name: '',
        description: '',
        post: this.state.selectedChannels.indexOf('post') !== -1,
      },
      {
        id: this.props.communications.dynamicsId,
        name: '',
        description: '',
        sms: this.state.selectedChannels.indexOf('sms') !== -1,
      }
    ];

    if (this.props.uiSetting.progressStep === 'vertical') {
      return (
        <div id="membership-signup" className="materialize sidePane_Container" >
          {this.loadAdditionalCSS()}
          <Row>
            <div className="col s2 m2 lg2 xl2" style={{ marginTop: '4.8%' }}>
              {this.state.displayIndex !== this.state.summaryIndex + 1 &&
                <div className="container">
                  <ComponentSequence
                    displayIndex={this.state.displayIndex}
                    displayAllChildren={true}
                    renderSteps={this.renderProgressSteps}
                  >
                {/*     <span>Donation Amount</span>
                    <span>Your details</span>
                    <span>Payment details</span>
                    <span>Summary</span> */}
                  </ComponentSequence>
                </div>
              }
            </div>
            <div className="col s10 m10 lg10 xl10">
              <div id="membership-signup-body">
                {this.renderErrors()}
                <SpinningProgressWrapper
                  processing={this.state.isProcessing}
                  message={this.state.processingMessage || 'Loading...'}
                  style={{ maxWidth: '200px', margin: '0 auto' }}
                >
                  {this.state.displayIndex !== this.state.summaryIndex + 1 &&
                    <ComponentSequence
                      displayIndex={this.state.displayIndex}
                      displayAllChildren={true}
                    >
                      <ul className="collapsible setCollapsibleWidth">

                        <li id="gift_0">

                          <div id="giftDiv_0" className="collapsible-header active" onClick={() => this.handleLabelClick(0)}>
                            <i className="material-icons collapsibleHeaderColor">money</i><span className="collapsibleHeaderColor">Donation Amount</span>
                          </div>

                          <div id="giftBody_0" className="collapsible-body">
                            <SignupJourney.AmountSelection
                              donationAmounts={this.state.product.priceList}
                              donationAmountsMonthly={this.state.product.priceListMonthly}

                              amount={this.state.product.priceInPence}
                              titleText={this.props.donationAmountSelectionTitle}
                              disclaimerText={this.props.donationAmountSelectionDisclaimer}
                              Header={this.props.donationAmountSelectionHeader}
                              
                              styles={{

                                button: 'buttonLargeClass',
                                amount: 'beesAmountSelectionBackgroundColor',
                                selectedAmount: 'selectedAmount',
                                notSelectedAmount: 'notSelectedAmount',
                                donationAmountHeadingColor: 'donationAmountHeadingColor',
                                enterDonationColor: 'enterDonationColor',
                                notSelectedPackage: 'notSelectedPackage',
                                selectedPackage: 'selectedPackage',
                                packageRadioButton: 'packagePaymentMethodSelection',
                              }}

                              priceSymbol={priceSymbol}
                              useIBAN={(this.props.useIBANBIC !== undefined) ? this.props.useIBANBIC : true}
                              donationSelected={this.updateDonationDetails}
                              bankPaymentRadioButtonLabel={this.props.product.bankPaymentRadioButtonLabel}
                              bankPaymentRadioButtonLabel2={this.props.product.bankPaymentRadioButtonLabel2}
                              product={this.props.product}
                            />
                          </div>

                        </li>

                        <li id={'gift_' + this.state.personalDetailIndex} style={this.state.displayIndex < this.state.personalDetailIndex ? { pointerEvents: 'none' } : {}}>
                          <div
                            id={'giftDiv_' + this.state.personalDetailIndex}
                            className="collapsible-header"
                            onClick={() => this.handleLabelClick(this.state.personalDetailIndex)}
                          >
                            <i className="material-icons collapsibleHeaderColor">people</i><span className="collapsibleHeaderColor">Personal Details</span>
                          </div>
                          <div id={'giftBody_' + this.state.personalDetailIndex} className="collapsible-body">
                            <SignupJourney.BarnardosPersonalDetails
                              loqateApiKey={this.props.loqateApiKey}

                              product={this.state.product}
                              member={this.state.primaryMember}
                              project={this.props.project}
                              isAddressFinderEnabled={this.props.addressSelectorEnabled}
                              isPhoneRegexValidation={true}
                              reCaptchaKey={this.props.reCaptchaKey}
                              countryList={this.props.countryList}

                              buttonClass="buttonLargeClass"
                              postalAdddressBackgroundClass="addressLocatorBackground"
                              commentEnabled={this.props.commentEnabled}
                              paymentSelection={this.state.product.paymentSelection}
                              updateMember={this.updateMember}
                              submit={this.handleNext}
                              showPreferNotToSay={false}
                              titlesList={titlesList}

                              showOrganisationField={this.props.showOrganisationField}

                              donationTypeDefaultId={this.props.donationTypeDefaultId}
                              donationTypeOptions={this.props.donationTypeOptions}
                              donationTypeOtherId={this.props.donationTypeOtherId}
                              setDonationTypeOption={this.donationTypeOptionSelected}
                              setCustomEntry={this.donationTypeCustomValueChanged}
                            >                            
                              <Modules.Gdpr
                                title={this.props.communications.title}
                                introduction={this.props.communications.introduction || ''}
                                disclaimer={this.props.communications.disclaimer || ''}

                                communications={gdprModuleCommunications}

                                headingColor="headingColor"

                                communicationUpdated={this.communicationUpdated}
                              >

                                {this.props.howHeardAboutUsOptions.length > 0 ? <Modules.HowHeardAboutUs
                                  options={this.props.howHeardAboutUsOptions}
                                  otherId={this.props.howHeardAboutUsOtherId}
                                  defaultId={this.props.howHeardAboutUsdefaultId}
                                  selectedOption={this.state.howHeardAboutUsSelectedId}
                                  customValue={this.state.howHeardAboutUsCustomValue}

                                  setHeardAboutOption={this.howHeardAboutUsOptionSelected}
                                  setCustomEntry={this.howHeardAboutUsCustomValueChanged}
                                /> : <></>}
                              </Modules.Gdpr>
                            </SignupJourney.BarnardosPersonalDetails>
                          </div></li>

                        <li id={'gift_' + this.state.paymentIndex} style={this.state.displayIndex < this.state.paymentIndex ? { pointerEvents: 'none' } : {}}>
                          <div id={'giftDiv_' + this.state.paymentIndex} className="collapsible-header " onClick={() => this.handleLabelClick(this.state.paymentIndex)}>
                            <i className="material-icons collapsibleHeaderColor">money</i><span className="collapsibleHeaderColor">Payment Details</span>
                          </div>

                          <div id={'giftBody_' + this.state.paymentIndex} className="collapsible-body">
                            <SignupJourney.Payment
                              annualPaymentAmountPence={this.state.product.priceInPence}
                              member={this.state.primaryMember}
                              paymentDetails={this.state.paymentDetails}
                              priceSymbol={priceSymbol}
                              cardTypes={this.state.product.cardTypeList}
                              paymentSelection={this.state.product.paymentSelection}
                              supportedPaymentKinds={
                                (this.state.product.paymentMethods) || [
                                  'directdebit',
                                  'creditcard',
                                  'bankaccount'
                                ]
                              }
                              buttonClass="buttonLargeClass"
                              loqateApiKey={this.props.loqateApiKey}
                              useLoqateValidation={(this.props.loqateValidation !== undefined) ? this.props.loqateValidation : false}
                              useIBANBIC={(this.props.useIBANBIC !== undefined) ? this.props.useIBANBIC : true}
                              updatePaymentDetails={this.updatePaymentDetails}
                              updateProcessingDisplay={this.updateProcessingDisplay}
                              submit={this.handleNext}
                              paymentErrorMessage={this.state.paymentErrorMessage}
                              ddMonth={this.state.ddMonth}
                              ddYear={this.state.ddYear}
                              ddType={this.props.ddType}
                              updatepaymentErrorDetail={this.updatepaymentErrorDetail}
                            />
                          </div>
                        </li>

                        <li id={'gift_' + this.state.summaryIndex} style={this.state.displayIndex < this.state.summaryIndex ? { pointerEvents: 'none' } : {}}>
                          <div id={'giftDiv_' + this.state.summaryIndex} className="collapsible-header" onClick={() => this.handleLabelClick(this.state.summaryIndex)}>
                            <i className="material-icons collapsibleHeaderColor">money</i><span className="collapsibleHeaderColor">Summary</span></div>
                          <div id={'giftBody_' + this.state.summaryIndex} className="collapsible-body">
                            <SignupJourney.Summary
                              member={this.state.primaryMember}
                              paymentDetails={this.state.paymentDetails}
                              giftAidEnabled={false}
                              giftAidOptions={{
                                addressLine1: '',
                                addressLine2: '',
                                addressLine3: '',
                                town: '',
                                county: '',
                                postcode: '',
                                country: '',
                                countryIso: '',
                              }}
                              buttonClass="buttonClass payNowMarginTop"
                              submitAreaBackgroundColor="addressLocatorBackground"
                              headingColor="headingColor"
                              priceSymbol={priceSymbol}
                              next={this.handleSubmit}
                              product={this.state.product}
                              useLoqateValidation={(this.props.loqateValidation !== undefined) ? this.props.loqateValidation : false}
                              goTo={(area: DonationArea) =>
                                this.setState({ ...this.state, activeArea: area })
                              }
                              termsAndConditionsText={this.props.termsAndConditionsText}
                              ddType={this.props.ddType}
                              creditorName={this.props.creditorName}
                              creditorID={this.props.creditorID}
                              creditorAddress={this.props.creditorAddress}
                              transactionType={this.getTransactionType(this.state.product.paymentSelection)}
                              ibanNumber={this.state.paymentDetails.kind === 'bankaccount' ? this.state.paymentDetails.iban : ''}
                              accountNumber={this.state.paymentDetails.kind === 'directdebit' ? this.state.paymentDetails.accountNumber : ''}
                              sortCode={this.state.paymentDetails.kind === 'directdebit' ? this.state.paymentDetails.sortCode : ''}
                            />
                          </div></li>
                      </ul>
                    </ComponentSequence>
                  }
                  {this.state.showThankyouMsg &&
                    <SignupJourney.ThankYouMessage
                      message={this.props.project.thankYouMessage}
                      donationAmount={this.state.product.priceInPence}
                      thankYouTextColor="thankYouTextColor"
                      priceSymbol={priceSymbol}
                      paymentSelection={this.state.product.paymentSelection}
                    />
                  }
                </SpinningProgressWrapper>
              </div>
            </div>
          </Row>
        </div>
      );
    } else {
      return (
     
        <Container id="membership-signup"  className="materialize sidePane_Container" >
          {this.loadAdditionalCSS()}
          {this.state.displayIndex !== 5 &&
           
          <div>
              <div className="container fixedHeader show-desktop">
                <div id="membership-signup-step-header" className="container">
                  <ComponentSequence
                    displayIndex={this.state.displayIndex}
                    displayAllChildren={false}
                    renderSteps={this.renderProgressSteps}
                  >
                    <span/> 
                    <span/> 
                    <span/> 
                    <span/>
                  </ComponentSequence>
                </div>
              </div>
              <div className="container fixedHeader show-mobile">
               
                <div id="membership-signup-step-header" className="container">
                  <ul id="dropdown" className="dropdown-content">
                    <li id="dd_0" className="active" onClick={() => this.handleLabelClick(0)}><span>Donation amount</span></li>
                    <li id={'dd_' + this.state.personalDetailIndex} onClick={() => this.handleLabelClick(this.state.personalDetailIndex)}><span>Your details</span></li>
                    <li id={'dd_' + this.state.paymentIndex} onClick={() => this.handleLabelClick(this.state.paymentIndex)}><span>Payment details</span></li>
                    <li id={'dd_' + this.state.summaryIndex} onClick={() => this.handleLabelClick(this.state.summaryIndex)}><span>Summary</span></li>
                  </ul>

                  <a className="btn dropdown-button menu" href="#" data-activates="dropdown">
                    <i className="material-icons">menu</i></a>
                </div>
               
              </div>
            </div>
          }

          <div id="membership-signup-body">
            {this.renderErrors()}
            <SpinningProgressWrapper
              processing={this.state.isProcessing}
              message={this.state.processingMessage || 'Loading...'}
              style={{ maxWidth: '200px', margin: '0 auto' }}
            >
              <ComponentSequence
                displayIndex={this.state.displayIndex}
                displayAllChildren={false}
              >

                <SignupJourney.AmountSelection
                  donationAmounts={this.state.product.priceList}
                  donationAmountsMonthly={this.state.product.priceListMonthly}

                  amount={this.state.product.priceInPence}

                  styles={{

                    button: 'buttonClass',
                    amount: 'beesAmountSelectionBackgroundColor',
                    selectedAmount: 'selectedAmount',
                    notSelectedAmount: 'notSelectedAmount',
                    donationAmountHeadingColor: 'donationAmountHeadingColor',
                    enterDonationColor: 'enterDonationColor',
                    notSelectedPackage: 'notSelectedPackage',
                    selectedPackage: 'selectedPackage',
                    packageRadioButton: 'packagePaymentMethodSelection',
                  }}

                  titleText={this.props.donationAmountSelectionTitle}
                  disclaimerText={this.props.donationAmountSelectionDisclaimer}
                  Header={this.props.donationAmountSelectionHeader}
                  priceSymbol={priceSymbol}
                  useIBAN={(this.props.useIBANBIC !== undefined) ? this.props.useIBANBIC : true}
                  donationSelected={this.updateDonationDetails}
                  bankPaymentRadioButtonLabel={this.props.product.bankPaymentRadioButtonLabel}
                  bankPaymentRadioButtonLabel2={this.props.product.bankPaymentRadioButtonLabel2}
                  product={this.props.product}

                />

                <SignupJourney.BarnardosPersonalDetails
                  loqateApiKey={this.props.loqateApiKey}

                  product={this.state.product}
                  member={this.state.primaryMember}
                  project={this.props.project}
                  isAddressFinderEnabled={this.props.addressSelectorEnabled}
                  isPhoneRegexValidation={true}
                  reCaptchaKey={this.props.reCaptchaKey}
                  countryList={this.props.countryList}

                  buttonClass="buttonLargeClass"
                  postalAdddressBackgroundClass="addressLocatorBackground"
                  commentEnabled={this.props.commentEnabled}
                  paymentSelection={this.state.product.paymentSelection}
                  updateMember={this.updateMember}
                  submit={this.handleNext}
                  showPreferNotToSay={false}
                  titlesList={titlesList}

                  showOrganisationField={this.props.showOrganisationField}
                  
                  donationTypeDefaultId={this.props.donationTypeDefaultId}
                  donationTypeOptions={this.props.donationTypeOptions}
                  donationTypeOtherId={this.props.donationTypeOtherId}
                  setDonationTypeOption={this.donationTypeOptionSelected}
                  setCustomEntry={this.donationTypeCustomValueChanged}
                >
                  <Modules.Gdpr
                    title={this.props.communications.title}
                    introduction={this.props.communications.introduction || ''}
                    disclaimer={this.props.communications.disclaimer || ''}

                    communications={gdprModuleCommunications}

                    headingColor="headingColor"

                    communicationUpdated={this.communicationUpdated}
                  >
<></>
                  </Modules.Gdpr>
                </SignupJourney.BarnardosPersonalDetails>

                <SignupJourney.Payment
                  annualPaymentAmountPence={this.state.product.priceInPence}
                  member={this.state.primaryMember}
                  paymentDetails={this.state.paymentDetails}
                  priceSymbol={priceSymbol}
                  cardTypes={this.state.product.cardTypeList}
                  paymentSelection={this.state.product.paymentSelection}
                  supportedPaymentKinds={
                    (this.state.product.paymentMethods) || [
                      'directdebit',
                      'creditcard',
                      'bankaccount'
                    ]
                  }

                  buttonClass="buttonLargeClass"
                  loqateApiKey={this.props.loqateApiKey}
                  useLoqateValidation={(this.props.loqateValidation !== undefined) ? this.props.loqateValidation : false}
                  useIBANBIC={(this.props.useIBANBIC !== undefined) ? this.props.useIBANBIC : true}
                  updatePaymentDetails={this.updatePaymentDetails}
                  updateProcessingDisplay={this.updateProcessingDisplay}
                  footerText={this.state.isDirectDebitEnable ? (this.props.footerText) : (' ')}
                  submit={this.handleNext}
                  paymentErrorMessage={this.state.paymentErrorMessage}
                  ddMonth={this.state.ddMonth}
                  ddYear={this.state.ddYear}
                  updatepaymentErrorDetail={this.updatepaymentErrorDetail}
                  ddType={this.props.ddType}
                />

                <SignupJourney.Summary
                  member={this.state.primaryMember}
                  paymentDetails={this.state.paymentDetails}

                  giftAidEnabled={false}
                  giftAidOptions={{
                    addressLine1: '',
                    addressLine2: '',
                    addressLine3: '',
                    town: '',
                    county: '',
                    postcode: '',
                    country: '',
                    countryIso: '',
                  }}
                  buttonClass="buttonClass payNowMarginTop"
                  submitAreaBackgroundColor="addressLocatorBackground"
                  headingColor="headingColor"
                  priceSymbol={priceSymbol}
                  product={this.state.product}
                  // tslint:disable-next-line:max-line-length
                  termsAndConditionsText={this.props.termsAndConditionsText}
                  ddType={this.props.ddType}
                  creditorName={this.props.creditorName}
                  creditorID={this.props.creditorID}
                  creditorAddress={this.props.creditorAddress}
                  transactionType={this.getTransactionType(this.state.product.paymentSelection)}
                  ibanNumber={this.state.paymentDetails.kind === 'bankaccount' ? this.state.paymentDetails.iban : ''}
                  useLoqateValidation={(this.props.loqateValidation !== undefined) ? this.props.loqateValidation : false}
                  accountNumber={this.state.paymentDetails.kind === 'directdebit' ? this.state.paymentDetails.accountNumber : ''}
                  sortCode={this.state.paymentDetails.kind === 'directdebit' ? this.state.paymentDetails.sortCode : ''}
                  next={
                    this.state.paymentDetails.kind === 'creditcard'
                      ? this.handleNext
                      : this.handleSubmit
                  }
                  goTo={(area: DonationArea) =>
                    this.setState({ ...this.state, activeArea: area })
                  }
                />

                {
                  this.state.paymentDetails.kind === 'creditcard' &&
                  <WorldNet3DSecure
                    evoApiUrl={this.props.rhythmApiUrl}
                    mpiUrl={this.props.worldNetConfig.mpiUrl}
                    terminalId={this.props.worldNetConfig.terminalId}
                    email={this.state.primaryMember.personalInfo.email}

                    amountInPence={this.state.product.priceInPence}
                    currency={'EUR'}

                    cardDetails={{
                      type: (this.state.paymentDetails as CardPaymentDetails).cardType as SupportedCards,
                      number: (this.state.paymentDetails as CardPaymentDetails).cardNumber,
                      holderName: (this.state.paymentDetails as CardPaymentDetails).cardHolderName,
                      expiryDate: (this.state.paymentDetails as CardPaymentDetails).expDate.month + (this.state.paymentDetails as CardPaymentDetails).expDate.year,
                      cvv: (this.state.paymentDetails as CardPaymentDetails).cvc
                    }}

                    worldNet3DSecureCallback={this.handleWorldNet3DSecureResponse}
                  />
                }

                <SignupJourney.ThankYouMessage
                  message={this.props.project.thankYouMessage}
                  donationAmount={this.state.product.priceInPence}
                  thankYouTextColor="thankYouTextColor"
                  priceSymbol={priceSymbol}
                  paymentSelection={this.state.product.paymentSelection}
                />
              </ComponentSequence>
            </SpinningProgressWrapper>
          </div>
        </Container>
      );
    }
  }
  componentDidMount() {
    this.updateAccordionIndex();
    $('.collapsible').collapsible();
    $('.dropdown-trigger').dropdown();
  }
}



// WEBPACK FOOTER //
// ./src/MakeDonation/BarnardosDonationForm.tsx